import { Flex, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { useKPSQspjdListQuery } from '../../../store/DianShangYeWuApi'
import RuleInvoiceAdd from './RuleInvoiceAdd'
import RuleInvoiceEdit from './RuleInvoiceEdit'
import RuleInvoiceCopy from './RuleInvoiceCopy'
function RuleInvoiceList(props) {
    const [list, setList] = useState([])
    const {data, isSuccess} = useKPSQspjdListQuery({kpsq_spjd_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setList(data.Result)
            }else{
            setList([])
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '操作',
            dataIndex: 'kpsq_spjd_id',
            key: 'kpsq_spjd_id',
            render: (text, record) => <RuleInvoiceCopy 
                                        kpsq_spjd_id={record.kpsq_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '开票申请规则名称',
            dataIndex: 'kpsq_spjd_content',
            key: 'kpsq_spjd_content',
            render: (text, record) => <RuleInvoiceEdit 
                                        kpsq_spjd_content={text} 
                                        kpsq_spjd_id={record.kpsq_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '开票申请部门',
            dataIndex: 'kpsq_spjd_bm_name',
            key: 'kpsq_spjd_bm_name',
        },
        {
            title: '开票申请操作员',
            dataIndex: 'kpsq_spjd_user_name',
            key: 'kpsq_spjd_user_name',
        },
        {
            title: '新增记录',
            dataIndex: 'kpsq_spjd_uname',
            key: 'kpsq_spjd_uname',
            render: (text, record) => <span>{record.kpsq_spjd_uname} {record.kpsq_spjd_ctime}</span>,
        }
       
    ]
    return (
        <>
            <Flex
                justify='space-between'
                align='center'
               
            >       
               <RuleInvoiceAdd 
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    useList={props.useList}
                    deptList={props.deptList}
               />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={false}
                rowKey='kpsq_spjd_id'
                size='small'
                bordered
                className="custom-table"
                style={{marginTop:'10px'}}
            />
        </>
    )
}

export default RuleInvoiceList